<template>
  <div>
    <LKProgressCircular
      v-if="rootNode.loading"
      overlay
      :size="50"
      style="align-items: start; padding-top: 200px;"
    />

    <LKRoadmapsFeedCardRoadmap
      v-if="roadmapNode"
      :node="roadmapNode"
      :load-children="onLoadChildren"

      v-on="$listeners || {}"
      @open-history="onOpenEventHitory"
      @change:status="onChangeEventStatus"
      @change:expert-status="onChangeExpertStatus"
      @change:date="onChangeEventDate"
    />

    <div
      v-else-if="!roadmapNode && !rootNode.loading"
      class="text-md"
      v-html="'Дорожной карты не существует'"
    />
  </div>
</template>

<script>
import LKProgressCircular from '@/components/lk/LKProgressCircular.vue'
import LKRoadmapsFeedTree, { LEVELS } from './LKRoadmapsFeedTree.vue'
import LKRoadmapsFeedCardRoadmap from './CardRoadmap/LKRoadmapsFeedCardRoadmap.vue'


export default {
  name: 'LKRoadmapsFeedRoadmapView',
  components: {
    LKProgressCircular,
    LKRoadmapsFeedCardRoadmap,
  },
  extends: LKRoadmapsFeedTree,
  props: {
    school: {
      type: Object,
      required: true,
    },
    roadmapId: {
      type: [Number, String],
    },
  },
  data: () => ({
    roadmapNode: null,
  }),
  methods: {
    async onInit() {
      const { rootNode, school } = this
      rootNode.setChildren([school.region])

      const regionNode = rootNode.children[0]
      regionNode.setChildren([school.municipality])

      const municipalityNode = regionNode.children[0]
      municipalityNode.setChildren([school])

      const schoolNode = municipalityNode.children[0]
      schoolNode.setChildren([{ id: this.roadmapId }])

      const roadmapNode = schoolNode.children[0]

      rootNode.loading = true

      await this.updateRoadmap(roadmapNode)
      await this.updateTreeChildren(roadmapNode, LEVELS.FILES)
      this.roadmapNode = roadmapNode

      this.roadmapNodes = this.roadmapNodes.concat(roadmapNode)
      rootNode.loading = false
    },
  },
}
</script>
